import { useEffect, useRef } from 'react';
import clsx from 'clsx';
import styles from './Textarea.module.css';

interface ITextareaProps {
  className?: string;
  fitContent?: boolean;
  rows?: number;
  placeholder?: string;
  value: string;
  onChange: (value: string) => void;
}

export const Textarea = (props: ITextareaProps) => {
  const ref = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    if (!props.fitContent || !ref.current) return;

    ref.current.style.height = '0';
    ref.current.style.height = `${ref.current.scrollHeight}px`;
  }, [props.fitContent, props.value, ref.current]);

  return (
    <textarea
      ref={ref}
      className={clsx(styles['textarea'], styles['textarea_on-ice'], props.className)}
      rows={props.rows}
      placeholder={props.placeholder}
      value={props.value}
      onChange={(e) => props.onChange(e.target.value)}
    />
  );
};
